import { useWebchatEmbedScript } from '~/hooks/webchat'
import { Share } from 'lucide-react'
import { Button, useSidebar } from '@bpinternal/ui-kit-next'
import { WebchatContent } from '~/features/webchat/components/WebchatContent'
import { useLocalStore } from '~/stores'

export function DesktopWebchat({
  children,
  botId,
  workspaceId,
}: {
  children: React.ReactNode
  botId: string
  workspaceId: string
}) {
  const { shareableLink } = useWebchatEmbedScript({ botId, workspaceId })
  const isDarkMode = useLocalStore((s) => s.theme === 'dark')

  const { open: sidebarOpen } = useSidebar()
  return (
    <div className="hidden h-full justify-between lg:flex">
      <div className={`bg-background ${sidebarOpen ? 'pr-0' : 'pr-6'} transition-all duration-300 ${'w-[50%]'}`}>
        {children}
      </div>
      <div
        className={`fixed right-0 top-0 h-screen transition-all duration-300 @container ${sidebarOpen ? 'md:w-[38%] xl:w-[42%]' : 'w-[50%]'}`}
      >
        <div
          className={`absolute -top-12 ml-5 h-[calc(120%+20px)] w-full  ${isDarkMode ? 'bg-neutral-200' : 'bg-neutral-100'}`}
          style={{
            backgroundImage: `
              linear-gradient(to right, ${isDarkMode ? 'rgba(255, 255, 255, 0.3)' : 'rgba(229, 231, 235, 0.7)'} 0.5px, transparent 1px),
              linear-gradient(to bottom, ${isDarkMode ? 'rgba(255, 255, 255, 0.3)' : 'rgba(229, 231, 235, 0.7)'} 0.5px, transparent 1px)
                `,
            backgroundSize: '20px 20px',
          }}
        />
        <div className="flex h-full flex-col">
          <Button
            disabled={!shareableLink}
            variant="outline"
            className="z-[999] mr-5 mt-20 self-end"
            onClick={() => {
              window.open(shareableLink ?? '', '_blank')
            }}
          >
            <Share className="h-4 w-4" />
            Share
          </Button>
          <div className="ml-5 flex h-full w-full items-center justify-center">
            <WebchatContent botId={botId} workspaceId={workspaceId} />
          </div>
        </div>
      </div>
    </div>
  )
}
